import { Injectable } from '@angular/core';
import { HttpUtilService } from 'src/app/services/common/http-util.service';
import { environment } from 'src/environments/environment';
import { GetAccountRequest } from '../../models/account/get-account-request.model';
import { Observable } from 'rxjs';
import { GetAccountResponse } from '../../models/account/get-account-response.model';
import { ResponseResult } from 'src/app/api/common/models/response-result.model';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(private http: HttpUtilService) {}

  //#region -------------------- constant ----------------------
  readonly URL: string = environment.apiAuth;
  readonly URL_ACCOUNT: string = this.URL + '/api/Account/';
  //#endregion

  getAccount(body: GetAccountRequest): Observable<GetAccountResponse> {
    return this.http.post(this.URL_ACCOUNT + `GetAccount`, body);
  }

  getIsActive(): Observable<ResponseResult<boolean>> {
    return this.http.get(this.URL_ACCOUNT + `GetIsActive`);
  }
}
